import * as React from "react";

function IconBase({ children, className = "", ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  );
}

export function Mail(props) {
  return (
    <IconBase {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </IconBase>
  );
}

export function Phone(props) {
  return (
    <IconBase {...props}>
      <path d="M22 16.9v2a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1A19.5 19.5 0 0 1 4.2 12.8 19.8 19.8 0 0 1 1.1 4.2 2 2 0 0 1 3.1 2h2a2 2 0 0 1 2 1.7c.1 1 .4 2.1.8 3.1a2 2 0 0 1-.5 2.1L6.9 10a16 16 0 0 0 7.1 7.1l1.1-1.1a2 2 0 0 1 2.1-.5c1 .4 2 .7 3.1.8a2 2 0 0 1 1.7 2.6z" />
    </IconBase>
  );
}

export function MapPin(props) {
  return (
    <IconBase {...props}>
      <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z" />
      <circle cx="12" cy="10" r="3" />
    </IconBase>
  );
}

export function ChevronDown(props) {
  return (
    <IconBase {...props}>
      <path d="M6 9l6 6 6-6" />
    </IconBase>
  );
}

export function Menu(props) {
  return (
    <IconBase {...props}>
      <path d="M4 6h16" />
      <path d="M4 12h16" />
      <path d="M4 18h16" />
    </IconBase>
  );
}

export function Heart(props) {
  return (
    <IconBase {...props}>
      <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" />
    </IconBase>
  );
}

export function Check(props) {
  return (
    <IconBase {...props}>
      <path d="M20 6L9 17l-5-5" />
    </IconBase>
  );
}

export function User(props) {
  return (
    <IconBase {...props}>
      <path d="M20 21a8 8 0 0 0-16 0" />
      <circle cx="12" cy="7" r="4" />
    </IconBase>
  );
}

export function Users(props) {
  return (
    <IconBase {...props}>
      <path d="M17 21a7 7 0 0 0-14 0" />
      <circle cx="10" cy="8" r="3" />
      <path d="M23 21a6 6 0 0 0-6-6" />
      <circle cx="17" cy="8" r="3" />
    </IconBase>
  );
}

export function Sun(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="M4.9 4.9l1.4 1.4" />
      <path d="M17.7 17.7l1.4 1.4" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="M4.9 19.1l1.4-1.4" />
      <path d="M17.7 6.3l1.4-1.4" />
    </IconBase>
  );
}

export function CreditCard(props) {
  return (
    <IconBase {...props}>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </IconBase>
  );
}

export function ArrowRight(props) {
  return (
    <IconBase {...props}>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </IconBase>
  );
}

export function CheckCircle(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </IconBase>
  );
}

export function Layers(props) {
  return (
    <IconBase {...props}>
      <path d="m12.8 2.9 9.5 5.5c.4.2.4.8 0 1l-9.5 5.6a2 2 0 0 1-2 0L1.3 9.4c-.4-.2-.4-.8 0-1l9.5-5.5a2 2 0 0 1 2 0z" />
      <path d="m1.3 14.4 9.5 5.6a2 2 0 0 0 2 0l9.5-5.6" />
      <path d="m1.3 19.4 9.5 5.6a2 2 0 0 0 2 0l9.5-5.6" />
    </IconBase>
  );
}

export function MessageCircle(props) {
  return (
    <IconBase {...props}>
      <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z" />
    </IconBase>
  );
}

export function HeartCrack(props) {
  return (
    <IconBase {...props}>
      <path d="M19 14c1.5-2 2.2-3.2 2.5-4.5A5.5 5.5 0 0 0 12 5.8a5.5 5.5 0 0 0-9.5 3.7c.3 1.3 1 2.5 2.5 4.5L12 21Z" />
      <path d="m12 13-1-1 2-2-3-3 2-2" />
    </IconBase>
  );
}

export function Anchor(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="5" r="3" />
      <path d="M12 22V8" />
      <path d="M5 12H2a10 10 0 0 0 20 0h-3" />
    </IconBase>
  );
}

export function CloudRain(props) {
  return (
    <IconBase {...props}>
      <path d="M20 16.2A4.5 4.5 0 0 0 17.5 8h-1.8A7 7 0 1 0 4 14.9" />
      <path d="M16 14v6" />
      <path d="M8 14v6" />
      <path d="M12 16v6" />
    </IconBase>
  );
}

export function Repeat(props) {
  return (
    <IconBase {...props}>
      <path d="m17 2 4 4-4 4" />
      <path d="M3 11v-1a4 4 0 0 1 4-4h14" />
      <path d="m7 22-4-4 4-4" />
      <path d="M21 13v1a4 4 0 0 1-4 4H3" />
    </IconBase>
  );
}

export function Compass(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m16.2 7.8-2 6.3-6.4 2.1 2-6.3Z" />
    </IconBase>
  );
}

export function Video(props) {
  return (
    <IconBase {...props}>
      <path d="m16 13 5.2 3a.5.5 0 0 0 .8-.4V8.4a.5.5 0 0 0-.8-.4L16 11z" />
      <rect x="2" y="6" width="14" height="12" rx="2" />
    </IconBase>
  );
}

export function Home(props) {
  return (
    <IconBase {...props}>
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <path d="M9 22V12h6v10" />
    </IconBase>
  );
}

export function Clock(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </IconBase>
  );
}

export function Shield(props) {
  return (
    <IconBase {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </IconBase>
  );
}

export function Wifi(props) {
  return (
    <IconBase {...props}>
      <path d="M5 13a10 10 0 0 1 14 0" />
      <path d="M8.5 16.5a5 5 0 0 1 7 0" />
      <path d="M2 8.8a15 15 0 0 1 20 0" />
      <circle cx="12" cy="20" r="1" />
    </IconBase>
  );
}

export function ShieldCheck(props) {
  return (
    <IconBase {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="m9 12 2 2 4-4" />
    </IconBase>
  );
}

export function FileText(props) {
  return (
    <IconBase {...props}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
      <path d="M10 9H8" />
    </IconBase>
  );
}

export function GraduationCap(props) {
  return (
    <IconBase {...props}>
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </IconBase>
  );
}

export function DollarSign(props) {
  return (
    <IconBase {...props}>
      <path d="M12 2v20" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </IconBase>
  );
}

export function Award(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="8" r="6" />
      <path d="M15.5 14 12 22l-3.5-8z" />
      <path d="m8.5 14 3.5 8 3.5-8" />
    </IconBase>
  );
}

export function Search(props) {
  return (
    <IconBase {...props}>
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </IconBase>
  );
}

export function Calendar(props) {
  return (
    <IconBase {...props}>
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
      <line x1="16" x2="16" y1="2" y2="6" />
      <line x1="8" x2="8" y1="2" y2="6" />
      <line x1="3" x2="21" y1="10" y2="10" />
    </IconBase>
  );
}
